var $ = jQuery;
$(document).ready(function () {
    window.onload = function() {
        document.addEventListener("contextmenu", function(e){
            e.preventDefault();
        }, false);
        document.addEventListener("keydown", function(e) {
            //document.onkeydown = function(e) {
            // "I" key
            if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
                disabledEvent(e);
            }
            // "J" key
            if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
                disabledEvent(e);
            }
            // "S" key + macOS
            if (e.keyCode == 83 && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)) {
                disabledEvent(e);
            }
            // "U" key
            if (e.ctrlKey && e.keyCode == 85) {
                disabledEvent(e);
            }
            // "F12" key
            if (event.keyCode == 123) {
                disabledEvent(e);
            }
        }, false);
        function disabledEvent(e){
            if (e.stopPropagation){
                e.stopPropagation();
            } else if (window.event){
                window.event.cancelBubble = true;
            }
            e.preventDefault();
            return false;
        }
    };



    animatedScroll();
    hero();
    advBtn();
    mainMenu();
    featPropertySlick();
    gallery();
    lgallery();
    popups();
    submitLoad();
    viewOption();
    sortForm();
    searchQuery();


});


/* --------------------
 ADD PROPERTY JS
 ---------------------- */
function addproperty() {
    var _addbutton = $('.js-addproperty');
    if(!_addbutton.length) {return;}

    _addbutton.on('click',function () {
        $('html, body').animate({ scrollTop: $('#addpropertyform').offset().top }, 'slow');
    });
}
//mod20-tabs
function advBtn() {
    const _adv = $('.advBtn');
    const _advsearch = $('.advance-search');
    if(!_adv.length) {return;}

    _adv.on('click',function () {
       if($(this).hasClass('clicked')) {
           $(this).removeClass('clicked');
           _advsearch.removeClass('display');
           $('html,body').removeClass('stopscroll');
       } else {
           $(this).addClass('clicked');
           _advsearch.addClass('display');
           $('html,body').addClass('stopscroll');
       }
    });

    $('.advClose').on('click',function () {
       _adv.click();
    });

}
const animatedScroll = () => {
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: ($($.attr(this, 'href')).offset().top) - 100
        }, 800);
    });
}

/* --------------------
 EMAILER TRIGGER JS
 ---------------------- */
function emailer() {
    var _emailerpage = $('.js-mailer');
    if(!_emailerpage.length) {return;}

    $('#sendownermail').on('submit',function () {
        alert('Email Sent!');
    });
}
/* --------------------
 LBOX
 ---------------------- */
function lbox() {
    var _singlemode = $('.js-lbox');
    if(!_singlemode.length) {return;}

    $("a[rel=proplbox]").fancybox({
        'transitionIn'		: 'none',
        'transitionOut'		: 'none',
        'titlePosition' 	: 'over',
        'titleFormat'       : function(title, currentArray, currentIndex, currentOpts) {
            return '<span id="fancybox-title-over">Image ' +  (currentIndex + 1) + ' / ' + currentArray.length + ' ' + title + '</span>';
        }
    });
}
function featPropertySlick() {
    var _fp = $('.js-feat-slick');
    if (!_fp.length) {
        return;
    }

    _fp.slick({
        centerMode: false,
        slidesToShow: 4,
        arrows: true,
        infinite: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,

                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
}
/**
 * Created by torzrock on 10/03/2020.
 */
function wpfetch() {
    var _init = $('#wnews');
    var _posttype = [
        'finance','telecom','real_estate','government','contractors','it'
    ];
    var randomItem = _posttype[Math.floor(Math.random() * _posttype.length)];
    var serviesTitle = randomItem.replace("_", " ");
    var servicesAPI = 'https://newsapi.org/v2/everything?q=covid-19&language=en&sources=bbc-news&apiKey=3e58a0eefb294dcba738f481a60725d2';
    var servicesAPI2 = 'https://newsapi.org/v2/everything?q=real-estate&language=en&sources=bbc-news&apiKey=3e58a0eefb294dcba738f481a60725d2';


    //console.log(servicesAPI);
    if (!_init.length) {
        return;
    }

    $.get(servicesAPI, function (response) {
        // Loop through all the posts returned and console.log() each of
        // their HTML content
        $.each(response.articles, function(index, post) {
            var id = post.id;
            var link = post.link;
            var address = post.company_address;
            var title = post.title;
            var image = post.urlToImage;
            var description = post.description;
            var url = post.url;
            var source = post.source.name;


            //console.log(title);

            $('<div class="newscard"><div class="newscard-media" style="background-image: url('+ image + ')"></div><div class="newscard-text"><h3><a href="'+ url +'" target="_blank">'+ title +'</a></h3><small>'+source+'</small><p>'+ description +'</p></div></div>').appendTo("#wnews");
            if ( index === 1 ) {
                return false;
            }

        });
    });

    $.get(servicesAPI2, function (response) {
        // Loop through all the posts returned and console.log() each of
        // their HTML content
        $.each(response.articles, function(index, post) {
            var id = post.id;
            var link = post.link;
            var address = post.company_address;
            var title = post.title;
            var image = post.urlToImage;
            var description = post.description;
            var url = post.url;
            var source = post.source.name;


            //console.log(title);

            $('<div class="newscard"><div class="newscard-media" style="background-image: url('+ image + ')"></div><div class="newscard-text"><h3><a href="'+ url +'" target="_blank">'+ title +'</a></h3><small>'+source+'</small><p>'+ description +'</p></div></div>').appendTo("#wbuss");
            if ( index === 1 ) {
                return false;
            }

        });
    });


}
/* --------------------
 NEAREST PROPERTY
 ---------------------- */
function getcitylocation() {
    var _home = $('body.home');
    if(!_home.length) {return;}
    if (location.protocol == 'https:' && "geolocation" in navigator) {
        if (window.navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                    var lat 	 = position.coords.latitude,
                        lng 	 = position.coords.longitude,
                        latlng 	 = new google.maps.LatLng(lat, lng),
                        geocoder = new google.maps.Geocoder();
                    geocoder.geocode({'latLng': latlng}, function(results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[1]) {
                                for (var i = 0; i < results.length; i++) {
                                    if (results[i].types[0] === "locality") {
                                        var currentcity = results[i].address_components[0].short_name;
                                        var state = results[i].address_components[2].short_name;
                                        //$("input[name='location']").val(city + ", " + state);
                                        //console.log(currentcity);
                                        window.location.href = window.location.href + '?currentcity=' + currentcity;

                                    }
                                }
                            }
                            else {console.log("No reverse geocode results.")}
                        }
                        else {console.log("Geocoder failed: " + status)}
                    });
                },
                function() {console.log("Geolocation not available.")});
        }
    }


}

/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function hero() {
    var _singlemode = $('.js-hero');
    if(!_singlemode.length) {return;}



    _singlemode.slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        //centerMode: true,
        lazyLoad: 'ondemand',
        pauseOnHover: false,
        cssEase: 'linear',
        speed: 1500,
        fade: true
    });

}
/* --------------------
 MODAL KULIT
 ---------------------- */
function modalKulit() {
    var _kulit = $('.js-kulit');
    if(!_kulit.length) {return;}

    if($('body').hasClass('home')) {
        setTimeout(function(){
            _kulit.show();
            $('.overlay').show();
        }, 10000);
    } else {
        setTimeout(function(){
            _kulit.show();
            $('.overlay').show();
        }, 20000);
    }



    $('.closekulit').on('click',function () {
        _kulit.hide();
        $('.overlay').hide();
    });
}
function lazyImg() {
    $('.lazy').Lazy({
        // your configuration goes here
        scrollDirection: 'both',
        effect: 'fadeIn',
        effectTime: 1000,
        delay: 200,
        //visibleOnly: true,
        onError: function(element) {
            console.log('error loading ' + element.data('src'));
        }
    });
}

/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function lgallery() {
    var _gal = $('#gallery');
    if(!_gal.length) {return;}

    lightGallery(document.querySelector('.slick-track'));

}
/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function gallery() {
    var _singlemode = $('#gallery');
    var _item = $('#gallery a').length - 1;
    if(!_singlemode.length) {return;}



    _singlemode.slick({
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        pauseOnHover: false,
        cssEase: 'linear',
        speed: 800,
        asNavFor: '#gallery-nav',
    });
    if(_item < 3) {
        $('#gallery-nav').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '#gallery',
            dots: false,
            focusOnSelect: true,
            centerMode: true,
            arrows: false,
        });
    } else{
        $('#gallery-nav').slick({
            infinite: true,
            slidesToShow: _item,
            slidesToScroll: 1,
            asNavFor: '#gallery',
            dots: false,
            focusOnSelect: true,
            centerMode: true,
            arrows: false,
        });
    }


}
/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function heroslider() {
    var _hero = $('.js-homebanner');
    if(!_hero.length) {return;}

    _hero.slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        speed: 1000,
        fade: false
    });
}
function heroslider2() {
    var _hero = $('.js-homebanner2');
    if(!_hero.length) {return;}

    _hero.slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        speed: 1000,
        fade: false,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                    arrows: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    });
}
function homemap() {
    var _map = $('.js-homemap');
    var _mapContainer = 'map';

    if(!_map.length) {return;}
    getLocation();





}
function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
    } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
    }
}
function showPosition(position) {
    var _lat = position.coords.latitude;
    var _long = position.coords.longitude;

    var map = L.map(_mapContainer).setView([_lat, _long], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    var LeafIcon = L.Icon.extend({
        options: {
            shadowUrl: 'leaf-shadow.png',
            iconSize:     [38, 95],
            shadowSize:   [50, 64],
            iconAnchor:   [22, 94],
            shadowAnchor: [4, 62],
            popupAnchor:  [-3, -76]
        }
    });

    var greenIcon = new LeafIcon({iconUrl: 'leaf-green.png'}),
        redIcon = new LeafIcon({iconUrl: 'leaf-red.png'}),
        orangeIcon = new LeafIcon({iconUrl: 'leaf-orange.png'});

    L.marker([51.5, -0.09], {icon: greenIcon}).bindPopup("I am a green leaf.").addTo(map);
    L.marker([51.495, -0.083], {icon: redIcon}).bindPopup("I am a red leaf.").addTo(map);
    L.marker([51.49, -0.1], {icon: orangeIcon}).bindPopup("I am an orange leaf.").addTo(map);
}
/* --------------------
 MAIN MENU JS
 ---------------------- */
function mainMenu() {
    var _menu = $('.js-menubutton');
    var _menuContainer = $('.mega-menu-main');
    if(!_menu.length) {return;}

    _menu.on('click',function () {
        if($(this).hasClass('open')) {
            $(this).removeClass('open');
            _menuContainer.removeClass('open');
            $('.menuoverlay').remove();
            $('html,body').removeClass('stopscroll');
        } else {
            $(this).addClass('open');
            _menuContainer.addClass('open');
            $('.module-site-header').append('<div class="menuoverlay"></div>');
            $('html,body').addClass('stopscroll');
        }
    });


}
/* --------------------
 MAIN MENU AND LOGO WHEN PAGE SCROLL
 ---------------------- */
function navscroll() {
    var _mainmenu = $('#topbar');
    if(!_mainmenu.length) {return;}


    $(window).scroll(function(){
        if ($(window).scrollTop() <= 40) {
            _mainmenu.removeClass('moved');
        } else {
            _mainmenu.addClass('moved');
        }
    });
}


function avatarsize() {
    var _avatar = $('.js-avatar');
    if(!_avatar.length) {return;}


    _avatar.each(function () {
        var _imgSrc = $(this).children('img').attr('src');
        var _newImgSrc = _imgSrc.split("_uwp_avatar_thumb").join('');
        $(this).css('background-image', 'url(' + _newImgSrc + ')');
    });

}
function slickResponsive() {
    var _avatar = $('.js-slickresponsive,.js-slider');
    if (!_avatar.length) {
        return;
    }


    _avatar.slick({
        centerMode: false,
        centerPadding: '5px',
        slidesToShow: 2,
        arrows: true,
        infinite: true,
        dots: false,
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    infinite: true,
                    dots: false,
                    arrows: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            }
        ]
    });
}
function numberformat() {
    var _num = $('.js-numberformat');
    if(!_num.length) {return;}



    _num.on( "keyup", function( event ) {
        // When user select text in the document, also abort.
        var selection = window.getSelection().toString();
        if ( selection !== '' ) {
            return;
        }
        // When the arrow keys are pressed, abort.
        if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
            return;
        }


        var $this = $( this );

        // Get the value.
        var input = $this.val();

        var input = input.replace(/[\D\s\._\-]+/g, "");
        input = input ? parseInt( input, 10 ) : 0;

        $this.val( function() {
            return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );
        } );
    } );

}
function popups() {
    const _splash = $('.js-popup-form');
    const _splashTime = $('.js-popup-form').data('time');
    //console.log('time:'+_splashTime);
    //let getsess = window.sessionStorage.getItem('wasVisited');

    if(!_splash.length) {
        //window.sessionStorage.removeItem('wasVisited');
        return;
    }


    setTimeout(function (){
        // The viewport is less than 768 pixels wide
        console.log('lock and loaded');
        _splash.fadeIn('slow');
        //$('#playt').trigger('play');
        $('body').prepend('<div class="overlay"></div>');
        $('html,body').addClass('stopscroll');
    },_splashTime);


    // if(window.matchMedia("(max-width: 767px)").matches){
    //     setTimeout(function (){
    //         // The viewport is less than 768 pixels wide
    //         console.log('lock and loaded');
    //         _splash.fadeIn('slow');
    //         $('#playt').trigger('play');
    //         $('body').prepend('<div class="overlay"></div>');
    //         $('html,body').addClass('stopscroll');
    //     },10000);
    // } else {
    //     let video = document.getElementById("playt");
    //     if ( video.readyState === 4 ) {
    //         console.log('lock and loaded');
    //         _splash.fadeIn('slow');
    //         //$('#playt').trigger('play');
    //         $('body').prepend('<div class="overlay"></div>');
    //         $('html,body').addClass('stopscroll');
    //     }
    // }

    // if(getsess === null) {
    //
    //
    // } else {
    //     _splash.remove();
    // }



    $('.close-form').on('click',function () {
        _splash.remove();
        $('.overlay').remove();
        $('html,body').removeClass('stopscroll');
    });




}
function qsCarousel() {
    var _qs = $('.qsearch-carousel');
    if (!_qs.length) {
        return;
    }


    _qs.slick({
        centerMode: false,
        centerPadding: '0px',
        slidesToShow: 4,
        arrows: true,
        infinite: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000
    });
}
function radio() {
    var _num = $('.js-radio');
    if(!_num.length) {return;}
    console.log('radiojs activated');

    $('label').on('click', function () {
        if ($('input:radio').is(':checked')) {
            console.log('click');
            $('label.checked').siblings('label').removeClass('checked');
            $(this).addClass('checked');
        }
    })





}
function searchfull() {
    var _num = $('.js-searchfull');
    if(!_num.length) {return;}

    _num.on('focus',function () {
        $('.searchboxfull').addClass('open');
        $('.searchboxfull input[type=search]').focus();

    });

    $('.closefullbox').on('click',function () {
        $('.searchboxfull input[type=search]').blur();
        $('.searchboxfull').removeClass('open');
    });




}
const searchQuery = () => {
    const heroForm = $('#heroform');
    const heroFormRadio = $('#heroform input[name=ctype]');
    const heroFormSearch = $('#heroform input[name=search]');
    const searchForm = $('#mainPropertyForm');
    const searchFormSelect = $('#mainPropertyForm select');
    const searchFormInputText = $('#mainPropertyForm input[name=search]');
    const searchFormPhrase = $('#mainPropertyForm input[name=phrase]');
    const searchFormRadio = $('#mainPropertyForm input[name=minPrice],#mainPropertyForm input[name=maxPrice],#mainPropertyForm input[name=view]');
    if(searchForm.length) {
        searchForm.on('submit',function (){
            searchFormSelect.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });

            searchFormPhrase.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });
            searchFormInputText.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });
            searchFormRadio.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });
        });
    }
    if(heroForm.length){
        heroForm.on('submit',function (){
            heroFormRadio.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });
            heroFormSearch.each(function (){
                if($(this).val() == ''){
                    $(this).attr('disabled','disabled');
                }
            });
        });
    }



}

const submitLoad = () => {
    const searchForm = $('#mainPropertyForm');
    searchForm.on('submit',function () {
        $('body').prepend('<section class="query"> <div> <span></span> Loading...</div> </section>');
    });
}
/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function sortForm() {
    var _sop = $('#mainPropertyForm');

    if(!_sop.length) {return;}

    $('select[name="sortby"]').on('change',function () {
        _sop.submit();
    });

}
//mod20-tabs
function tabs() {
    var _tabs = $('.mod20-tabs');
    if(!_tabs.length) {return;}

    console.log('radiojs activated');

    var _control = $('.mod20-tabs h3');

    _control.on('click',function(){
        if(!$(this).is('.active')) {
            var _controlId = $(this).attr('id');
            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            $('.' + _controlId).show();
            $('.' + _controlId).siblings('section').hide();

        }
    })









}
/* --------------------
 HOMEPAGE BANNER JS
 ---------------------- */
function viewOption() {
    var _vop = $('.ere-search-result');
    var _vopAnchor = $('.viewoption input[type=radio]');
    if(!_vop.length) {return;}

    _vopAnchor.on('change',function () {
        console.log($(this).val());
        $('#mainPropertyForm').submit();
        // if(!$(this).hasClass('active')) {
        //     var _cname = $(this).data('id');
        //     $(this).addClass('active').siblings('a').removeClass('active');
        //     _vop.children('.ere-container').toggleClass('list');
        //     _vop.children().children('.ere-search-result-container').toggleClass('list');
        // } else {
        //     $()
        // }
    })

}
/* --------------------
 VRTOUR TRIGGER JS
 ---------------------- */
function vrBtn() {
    var _bTn = $('.vrtour-btn');
    if(!_bTn.length) {return;}

    _bTn.on('click',function () {
       $('.vtour_cont').css({opacity: '1',pointerEvents: 'auto'});
       $('html').css({overflow: 'hidden'})
    });
    $('.close-vr').on('click',function () {
        $('html').removeAttr('style');
        $('.vtour_cont').removeAttr('style');
    });
}